export default {
  save: 'Zapisz',
  cancel: 'Anuluj',
  no_results: 'Nic nie znaleziono',
}